/*  */
import { PhotoSwipeLightbox } from "vendor";
gsap.registerPlugin(ScrollTrigger)

const CONFIG = {
  /** 移动端断点（与 CSS media query 保持一致） */
  mobileBreakpoint: '(max-width: 768px)',
  desktopBreakpoint: '(min-width: 769px)',

  highlight: {
    start: 'top 85%',
    end: 'bottom 35%',
  },
  parallax: {
    yPercent: 16,
  },
  /** 沉浸式巨幕：Pin 区域滚动距离（视口倍数） */
  immersive: {
    scrollDistance: '150%',
  },
  polaroid: {
    scrollDistance: '130%',
  },
  spotlight: {
    scrollDistance: '220%',
  },
}

function initVlogAnimations() {
initTextScrubHighlight()
  initPolaroidStack()
  initPolaroidPhotoSwipe()
  ScrollTrigger.refresh()
}


function wrapTextIntoChars(element) {
  if (element.querySelector('.vlog-char')) return

  const fragment = document.createDocumentFragment()

  Array.from(element.textContent).forEach((char) => {
    const span = document.createElement('span')
    span.className = 'vlog-char'
    span.textContent = char === ' ' ? '\u00A0' : char
    span.style.display = 'inline-block'
    fragment.appendChild(span)
  })

  element.textContent = ''
  element.appendChild(fragment)
}

function initTextScrubHighlight() {
  const blocks = gsap.utils.toArray('.shopify-vlog-scoped .vlog-highlight-text')

  blocks.forEach((block) => {
    wrapTextIntoChars(block)

    const chars = block.querySelectorAll('.vlog-char')
    const activeColor = block.dataset.highlightColor || '#1a1a1a'
    const inactiveColor = block.dataset.inactiveColor || '#c8c8c8'

    gsap.set(chars, { color: inactiveColor })

    gsap.to(chars, {
      color: activeColor,
      ease: 'none',
      stagger: 0.035,
      scrollTrigger: {
        trigger: block,
        start: CONFIG.highlight.start,
        end: CONFIG.highlight.end,
        scrub: true,
      },
    })
  })
}

/*  */

// Module 5: .vlog-polaroid-stack
function getPolaroidOffsetScale() {
  return window.matchMedia(CONFIG.mobileBreakpoint).matches ? 0.55 : 1
}

function initPolaroidStack() {
  const stacks = gsap.utils.toArray('.vlog-polaroid-stack')

  stacks.forEach((stack) => {
    const stage = stack.querySelector('.vlog-polaroid-stage')
    const cards = gsap.utils.toArray(stack.querySelectorAll('.vlog-polaroid-item'))
    if (!stage || !cards.length) return

    gsap.set(cards, {
      opacity: 0,
      scale: 0.55,
      rotation: 35,
      x: 0,
      y: 0,
      transformOrigin: 'center center',
    })

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: stack,
        start: 'top top',
        // end: (=> `+=${Math.max(wind) ow.innerHeight * cards.length * (CONFIG.polaroid.scrollPerCard / 100), window.innerHeight)}`,
        end: () => {
      const scrollPercent = (CONFIG && CONFIG.polaroid && CONFIG.polaroid.scrollPerCard) ? CONFIG.polaroid.scrollPerCard : 100;
      const calculatedEnd = window.innerHeight * cards.length * (scrollPercent / 100);
      // 至少给个 2000px 或者 2 屏的保底距离，绝对不能让它塌陷为 0
      return `+=${Math.max(calculatedEnd, window.innerHeight * 1.8)}`;
    },
        // end: () => `+=${window.innerHeight * 1.8}` /
        pin: stage,
        scrub: 0.7,
        anticipatePin: 1,
        invalidateOnRefresh: true,
      },
    })

    cards.forEach((card, i) => {
      const offsetScale = getPolaroidOffsetScale()
      const rot = parseFloat(card.dataset.rotate) || 0
      const x = (parseFloat(card.dataset.x) || 0) * offsetScale
      const y = (parseFloat(card.dataset.y) || 0) * offsetScale
    //   const slot = 1 / cards.length

      tl.to(
        card,
        {
          opacity: 1,
          scale: 1,
          rotation: rot,
          x,
          y,
          zIndex: i + 1,
          ease: 'power2.out',
        //   duration: slot * 0.85,
          duration: 0.5,
        },
        // i * slot,
        i === 0 ? 0 : `>-=0.35` // 从第二张牌开始，在前一张牌播放到 0.15s 时（即提前 0.35s）就强行插入飞出！i * slot,
      )
    })
  })
}

// PhotoSwipe ? ???/?????????????? 1:1
function preloadPolaroidDimensions(stack) {
  stack.querySelectorAll('a.vlog-polaroid-link').forEach((link) => {
    const fullSrc = link.href
    if (!fullSrc) return

    const loader = new Image()
    loader.onload = () => {
      link.dataset.pswpWidth = String(loader.naturalWidth)
      link.dataset.pswpHeight = String(loader.naturalHeight)
    }
    loader.src = fullSrc
  })
}

function resolvePhotoSwipeSize(linkEl) {
  const cachedW = Number(linkEl.dataset.pswpWidth)
  const cachedH = Number(linkEl.dataset.pswpHeight)
  if (cachedW > 0 && cachedH > 0) {
    return { width: cachedW, height: cachedH }
  }

  const thumb = linkEl.querySelector('img')
  if (thumb?.naturalWidth > 0 && thumb?.naturalHeight > 0) {
    return { width: thumb.naturalWidth, height: thumb.naturalHeight }
  }

  return { width: 1600, height: 1067 }
}

function getPolaroidThumbBounds(itemData) {
  const link = itemData.element
  const item = link?.closest('.vlog-polaroid-item')
  if (!item) return null

  const frameRect = item.getBoundingClientRect()
  const img = link.querySelector('img')
  const imgRect = img?.getBoundingClientRect()

  return {
    x: frameRect.left,
    y: frameRect.top,
    w: frameRect.width,
    h: frameRect.height,
    innerRect: imgRect
      ? {
          x: imgRect.left,
          y: imgRect.top,
          w: imgRect.width,
          h: imgRect.height,
        }
      : undefined,
  }
}

function bindPolaroidPswpMotion(lightbox) {
  lightbox.on('afterInit', () => {
    const pswp = lightbox.pswp
    if (!pswp?.element) return

    pswp.element.classList.add('vlog-polaroid-pswp')
    pswp.element.style.setProperty(
      '--pswp-transition-duration',
      `${CONFIG.polaroid.pswpOpenDuration}ms`,
    )
  })

  lightbox.on('openingAnimationStart', () => {
    const pswp = lightbox.pswp
    if (!pswp?.element) return

    pswp.element.classList.remove('vlog-polaroid-pswp--closing')
    pswp.element.style.setProperty(
      '--pswp-transition-duration',
      `${CONFIG.polaroid.pswpOpenDuration}ms`,
    )

    const caption = pswp.element.querySelector('.vlog-polaroid-pswp-caption')
    gsap.fromTo(
      caption,
      { opacity: 0, y: 18 },
      { opacity: 1, y: 0, duration: 0.55, ease: 'power2.out', delay: 0.18 },
    )
  })

  lightbox.on('closingAnimationStart', () => {
    const pswp = lightbox.pswp
    if (!pswp?.element) return

    pswp.element.classList.add('vlog-polaroid-pswp--closing')
    pswp.element.style.setProperty(
      '--pswp-transition-duration',
      `${CONFIG.polaroid.pswpCloseDuration}ms`,
    )

    const caption = pswp.element.querySelector('.vlog-polaroid-pswp-caption')
    const ui = pswp.element.querySelector('.pswp__top-bar')

    gsap.to(caption, {
      opacity: 0,
      y: 14,
      duration: 0.42,
      ease: 'power2.inOut',
      overwrite: true,
    })

    if (ui) {
      gsap.to(ui, {
        opacity: 0,
        y: -8,
        duration: 0.35,
        ease: 'power2.in',
        overwrite: true,
      })
    }
  })

  lightbox.on('closingAnimationEnd', () => {
    lightbox.pswp?.element?.classList.remove('vlog-polaroid-pswp--closing')
  })
}

function initPolaroidPhotoSwipe() {
  const stacks = gsap.utils.toArray('.vlog-polaroid-stack')

  stacks.forEach((stack) => {
    preloadPolaroidDimensions(stack)

    const lightbox = new PhotoSwipeLightbox({
      gallery: stack,
      children: 'a.vlog-polaroid-link',
      pswpModule: () => import('photoswipe'),
      bgOpacity: 0.94,
      padding: { top: 20, bottom: 48, left: 16, right: 16 },
      showHideAnimationType: 'zoom',
      showAnimationDuration: CONFIG.polaroid.pswpOpenDuration,
      hideAnimationDuration: CONFIG.polaroid.pswpCloseDuration,
      easing: CONFIG.polaroid.pswpEasing,
    })

    lightbox.addFilter('domItemData', (itemData, _index, linkEl) => {
      const { width, height } = resolvePhotoSwipeSize(linkEl)
      itemData.width = width
      itemData.height = height
      itemData.src = linkEl.href
      itemData.msrc = linkEl.querySelector('img')?.currentSrc || linkEl.querySelector('img')?.src

      const caption = linkEl
        .closest('.vlog-polaroid-item')
        ?.querySelector('.vlog-polaroid-caption')
      if (caption) {
        itemData.alt = caption.textContent.trim()
      }

      return itemData
    })

    lightbox.addFilter('thumbBounds', (thumbBounds, itemData) => {
      return getPolaroidThumbBounds(itemData) || thumbBounds
    })

    bindPolaroidPswpMotion(lightbox)

    lightbox.on('uiRegister', () => {
      lightbox.pswp.ui.registerElement({
        name: 'vlog-polaroid-caption',
        order: 9,
        isButton: false,
        appendTo: 'root',
        html: '<div class="vlog-polaroid-pswp-caption"></div>',
        onInit: (el, pswp) => {
          pswp.on('change', () => {
            const link = pswp.currSlide?.data?.element
            const text = link
              ?.closest('.vlog-polaroid-item')
              ?.querySelector('.vlog-polaroid-caption')?.textContent
            el.querySelector('.vlog-polaroid-pswp-caption').textContent = text || ''
          })
        },
      })
    })

    lightbox.init()
  })
}


if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVlogAnimations)
} else {
  initVlogAnimations()
}

window.addEventListener('resize', () => {
  ScrollTrigger.refresh()
})
